import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  startDate: null,
  endDate: null
};
const dateSettingsSlice = createSlice({
  name: 'dateSettings',
  initialState,
  reducers: {
    setDateSettings: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    resetDateSettings: () => initialState
  },
  extraReducers: builder => {
    builder.addCase('settingsSyncSuccess', (state, action) => {
      if (action.payload) {
        const {
          startDate,
          endDate
        } = action.payload;
        return {
          ...state,
          ...(startDate !== undefined && {
            startDate
          }),
          ...(endDate !== undefined && {
            endDate
          })
        };
      }
      return state;
    });
  }
});
export const {
  setDateSettings,
  setStartDate,
  setEndDate,
  resetDateSettings
} = dateSettingsSlice.actions;
export default dateSettingsSlice.reducer;